require('./review-form.scss')

module.exports = {
  template: require('./review-form.pug')()
  controller: require('./review-form.ctrl')
  bindings:
    review: '<'
    onSubmit: '&'
}
